module Sm.Core.Numeric

let inline ( /. ) a b =
    float a / float b

let inline ( *. ) a b =
    float a * float b

let inline ( +. ) a b =
    float a + float b

module Bitfield64 =
    let mask (offset: int) (length: int) =
        if offset + length > 64 then 0UL
        else
            let x = 0xffffffff_ffffffffUL >>> (64 - length)
            x <<< offset

    let set offset length value target =
        let m = mask offset length
        let x = value <<< offset &&& m
        target ||| x

    let get offset length target =
        let m = mask offset length
        let x = target &&& m
        x >>> offset
